import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { AppShell } from "../navigation/AppShell";

export default function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect root to dashboard to avoid blank index under the layout.
  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/dashboard", { replace: true });
    }
  }, [location.pathname, navigate]);

  // Additional check for exact root path
  if (location.pathname === "/") {
    return null; // Prevent rendering while redirecting
  }

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
